export default __webpack_public_path__ + "static/media/msb-logo.da5374c6.svg";